$(function () {
  const accordion = $('.qa_list');

  accordion.each(function () {
    const noTargetAccordion = $(this).siblings(accordion);

    $(this)
      .find('dt')
      .click(function () {
        $(this).next('dd').slideToggle();
        $(this).toggleClass('open');
        noTargetAccordion.find('dd').slideUp();
        noTargetAccordion.find('dt').removeClass('open');
      });
  });
});
